import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { Observable } from 'rxjs';
import { PhotoGallery, Picture, Styling } from '@models/photo-gallery.model';
import { Customer } from '@models/customer.model';

export interface PhotoGalleryDTO {
  id: string;
  users: string[];
  babyName: string;
  slug: string;
  title: string;
  styling: Styling;
  pictures: Picture[];
  qrCode: string;
  creationDate: string;
  customer: Customer;
}

@Injectable({
  providedIn: 'root'
})
export class PhotoGalleryService {
  private readonly http = inject(HttpClient);


  private readonly ENDPOINT = 'photo-galleries';

  getAll(): Observable<PhotoGallery[]> {
    return this.http.get<PhotoGallery[]>(`${environment.apiBaseUrl}/${this.ENDPOINT}`);
  }

  update(photoGallery: Partial<PhotoGallery> & { id: string }): Observable<PhotoGallery> {
    return this.http.patch<PhotoGallery>(`${environment.apiBaseUrl}/${this.ENDPOINT}/${photoGallery.id}`, photoGallery);
  }

  create(photoGallery: PhotoGallery): Observable<PhotoGallery> {
    return this.http.post<PhotoGallery>(`${environment.apiBaseUrl}/${this.ENDPOINT}`, photoGallery);
  }

  delete(id: string): Observable<string> {
    return this.http.delete<string>(`${environment.apiBaseUrl}/${this.ENDPOINT}/${id}`);
  }
}
